const musculoskeletal=
[
    {symptom: "boneSwelling",
    displayAs: "Unexplained bone swelling",
    questionGroup:"siteDescriptionDuration"
    },

    {symptom: "fracture",
    displayAs: "Unexplained fracture",
    questionGroup:"siteDescriptionDuration"},

    {symptom: "stLump",
    displayAs:"Unexplained enlarging soft tissue lump",
    questionGroup:"siteDescriptionDuration" }
]


export default musculoskeletal